import React from "react";
import cvData from "../../data/cv";

const PUBLIC = process.env.PUBLIC_URL;

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

const CERT_ENRICHMENT = {
  "AWS Certified Cloud Practitioner": {
    id: "aws",
    description:
      "Validates cloud concepts, AWS services, security, and pricing — supporting mobile backends, APIs, storage, and CI/CD.",
    badgeImage: `${PUBLIC}/assets/certificates/aws-cloud-practitioner-badge.png`,
  },
  "ISTQB® CTFL Certified": {
    id: "istqb",
    description:
      "Foundation-level software testing certification covering test design, techniques, and quality practices for reliable app releases.",
    badgeImage: `${PUBLIC}/assets/certificates/istqb-ctfl-badge.png`,
  },
  "Professional Scrum Master™ I (PSM I)": {
    id: "psm",
    description:
      "Scrum Master certification for Agile delivery, team facilitation, and iterative product development (PSM I).",
    badgeImage: `${PUBLIC}/assets/certificates/psm-i-badge.png`,
  },
  '"O" Level Certification': {
    id: "olevel",
    description:
      "NIELIT foundation certification covering programming, computer fundamentals, DBMS, web design, and networking.",
    badgeImage: `${PUBLIC}/assets/certificates/nielit-o-level-badge.svg`,
  },
};

const certifications = cvData.certifications.map((cert) => ({
  ...cert,
  ...CERT_ENRICHMENT[cert.name],
}));

const formatCertDate = (dateStr) => {
  if (!dateStr) return null;
  const parts = dateStr.split("-");
  if (parts.length === 2) {
    return `${MONTHS[parseInt(parts[1], 10) - 1]} ${parts[0]}`;
  }
  return `${MONTHS[parseInt(parts[1], 10) - 1]} ${parts[0]}`;
};

const CertBadge = ({ cert, size = "md" }) => (
  <img
    src={cert.badgeImage}
    alt={`${cert.name} badge`}
    className={`cert-badge-image cert-badge-image--${size}`}
    loading="lazy"
  />
);

const CertVerifyLink = ({ cert }) =>
  cert.url ? (
    <a
      href={cert.url}
      className="cert-verify-link"
      target="_blank"
      rel="noreferrer"
    >
      Verify on Credly
    </a>
  ) : (
    <span className="cert-verify-link cert-verify-link--muted">No public badge</span>
  );

const Certifications = () => {
  return (
    <section
      className="colorlib-certifications"
      data-section="certifications"
      id="certifications"
    >
      <div className="colorlib-narrow-content">
        <div className="row">
          <div
            className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
            data-animate-effect="fadeInLeft"
          >
            <span className="heading-meta">Certifications</span>
            <h2 className="colorlib-heading">Certifications</h2>
          </div>
        </div>

        <div className="row animate-box" data-animate-effect="fadeInUp">
          <div className="col-md-12">
            <div className="cert-layout-table-wrap">
              <table className="cert-layout-table">
                <thead>
                  <tr>
                    <th>Badge</th>
                    <th>Certification</th>
                    <th>Issuer</th>
                    <th>Issued</th>
                    <th>Expires</th>
                    <th>Link</th>
                  </tr>
                </thead>
                <tbody>
                  {certifications.map((cert) => (
                    <tr key={cert.id}>
                      <td data-label="Badge">
                        <CertBadge cert={cert} size="sm" />
                      </td>
                      <td data-label="Certification">
                        <strong>{cert.name}</strong>
                        <p className="cert-table-desc">{cert.description}</p>
                      </td>
                      <td data-label="Issuer">{cert.issuer}</td>
                      <td data-label="Issued">{formatCertDate(cert.issued)}</td>
                      <td data-label="Expires">
                        {cert.expires ? formatCertDate(cert.expires) : "—"}
                      </td>
                      <td data-label="Link">
                        <CertVerifyLink cert={cert} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
